// Pilot vs paid tier limits
// Analyses and reports are always unrestricted (sells the upgrade)

export const PLAN_LIMITS = {
  pilot: {
    maxSeats: 5,
    maxCandidatesPerRun: 64,
    dailyRunCap: 5,
  },
  paid: {
    maxSeats: 25,
    maxCandidatesPerRun: 1024,
    dailyRunCap: Infinity,
  },
  // Interim caps; Plan 3 grounds them in L4 cost data. Mirrors
  // services/llm-proxy/planLimits.js -- keep both in sync (see the parity test in
  // planLimits.test.js).
  selfserve: { maxSeats: 5, maxCandidatesPerRun: 256, dailyRunCap: 25 },
};

/** Resolve limits for an org — missing plan field defaults to 'pilot' (fail-safe: an
 * org doc that lost its plan field must never silently grant unlimited compute).
 * M4: superadmin sessions carry org=null (AuthProvider skips membership lookup), which
 * fell into the pilot default and capped staff demos — pass { superadmin: true } to
 * resolve paid limits instead. */
export function getOrgLimits(org, opts) {
  if (opts?.superadmin) return { plan: 'paid', limits: PLAN_LIMITS.paid };
  const plan = org?.plan || 'pilot';
  return { plan, limits: PLAN_LIMITS[plan] || PLAN_LIMITS.pilot };
}
